import React from "react";
import AgentManagementBK from "layouts/BK/agent";

function AgentManagementCM() {
  return <AgentManagementBK />;
}

export default AgentManagementCM;
